import { Suspense, lazy } from "react"
import { Navigate } from "react-router-dom"

import SuspenseLoader from "src/components/SuspenseLoader"
import { getPlanPermissions } from "src/configs/planPermissions"
import PermissionGuard from "src/components/PermissionGuard"
import AdminGuard from "src/components/AdminGuard"

const MuralGuard = ({ children }) => {
  const perms = getPlanPermissions()
  return perms.muralInterativo ? children : <Navigate to="/extended-sidebar/menu/home" replace />
}

const MarketingGuard = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user')) || {}
  const perms = getPlanPermissions()
  return user.adm || perms.marketing ? children : <Navigate to="/extended-sidebar/menu/home" replace />
}

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  )

const Script = Loader(lazy(() => import("src/content/script/script")))
const Mural = Loader(lazy(() => import("src/content/mural/mural")))
const MuralConfig = Loader(lazy(() => import("src/content/mural/MuralConfigPage")))
const Clientes = Loader(lazy(() => import("src/content/clientes/clientes")))
const Plans = Loader(lazy(() => import("src/content/plans/plans")))
const Apps = Loader(lazy(() => import("src/content/apps/apps")))
const Reports = Loader(lazy(() => import("src/content/reports/reports")))
const RelatorioMensagensPorConta = Loader(lazy(() => import("src/content/reports/RelatorioMensagensPorConta")))
const RelatorioMonitorAcessos = Loader(lazy(() => import("src/content/reports/RelatorioMonitorAcessos")))
const RelatorioConexoesUsuario = Loader(lazy(() => import("src/content/reports/RelatorioConexoesUsuario")))
const IpDetalhes = Loader(lazy(() => import("src/content/reports/IpDetalhes")))
const Alerts = Loader(lazy(() => import("src/content/alerts/alerts")))
const Avisos = Loader(lazy(() => import("src/content/avisos/avisos")))
const Marketing = Loader(lazy(() => import("src/content/marketing/marketing")))
const AiSummarySchedules = Loader(lazy(() => import("src/content/aiSummarySchedules/aiSummarySchedules")))

const administrationRoutes = [
  {
    path: "mural",
    element: <PermissionGuard permissionKey="mural"><MuralGuard><Mural /></MuralGuard></PermissionGuard>,
  },
  {
    path: "mural-config",
    element: <PermissionGuard permissionKey="mural"><MuralGuard><MuralConfig /></MuralGuard></PermissionGuard>,
  },
  {
    path: "mural/settings/:tab",
    element: <PermissionGuard permissionKey="mural"><MuralGuard><Mural /></MuralGuard></PermissionGuard>,
  },
  {
    path: "mural/:screen",
    element: <PermissionGuard permissionKey="mural"><MuralGuard><Mural /></MuralGuard></PermissionGuard>,
  },
  {
    path: "mural/:screen/:subIndex",
    element: <PermissionGuard permissionKey="mural"><MuralGuard><Mural /></MuralGuard></PermissionGuard>,
  },
  {
    path: "",
    element: <Navigate to="home" replace />,
  },
  {
    path: "script",
    element: <AdminGuard><Script /></AdminGuard>,
  },
  {
    path: "avisos",
    element: <AdminGuard><Avisos /></AdminGuard>,
  },
  {
    path: "clientes",
    element: <AdminGuard><Clientes /></AdminGuard>,
  },
  {
    path: "plans",
    element: <AdminGuard><Plans /></AdminGuard>,
  },
  {
    path: "apps",
    element: <AdminGuard><Apps /></AdminGuard>,
  },
  {
    path: "reports",
    element: <AdminGuard><Reports /></AdminGuard>,
  },
  {
    path: "reports/mensagens-por-conta",
    element: <AdminGuard><RelatorioMensagensPorConta /></AdminGuard>,
  },
  {
    path: "reports/monitor-acessos",
    element: <AdminGuard><RelatorioMonitorAcessos /></AdminGuard>,
  },
  {
    path: "reports/conexoes-usuario",
    element: <AdminGuard><RelatorioConexoesUsuario /></AdminGuard>,
  },
  {
    path: "reports/ip-detalhes/:ip",
    element: <AdminGuard><IpDetalhes /></AdminGuard>,
  },
  {
    path: "alerts",
    element: <AdminGuard><Alerts /></AdminGuard>,
  },
  {
    path: "marketing",
    element: <MarketingGuard><Marketing /></MarketingGuard>,
  },
  {
    path: "ai-summary-schedules",
    element: <AdminGuard><AiSummarySchedules /></AdminGuard>,
  },
]

export default administrationRoutes
